import React from "react";
import { object, number, array, bool } from "prop-types";
import { Link } from "@quintype/components";
import get from "lodash/get";

import Headline from "../../atoms/headline";
import CardImage from "../../atoms/card-image";
import Placeholder from "../../atoms/icons/placeholder";
import { LabelWithBackground } from "../../atoms/label";

import "./card-image-type-3.m.css";

const CardImageType3 = ({ story, widths = [518, 292], isNcfNews }) => {
  const storyObj = story.story ? story.story : story;
  let imageView = null;
  let containerView = null;
  const referenceUrl = get(storyObj, ["metadata", "reference-url"], null);

  if (storyObj["story-template"] === "news-elsewhere") {
    imageView = (
      <div className="card-image-type-3" styleName="image-view">
        {storyObj["hero-image-s3-key"] ? (
          <CardImage story={storyObj} defaultWidth={259} aspectRatio={[16, 9]} imageType="image16x9" widths={widths} />
        ) : (
          <Placeholder />
        )}
        {isNcfNews ? <LabelWithBackground text="NCF in the NEWS" /> : null}
      </div>
    );
  } else {
    imageView = (
      <div className="card-image-type-3">
        {storyObj["hero-image-s3-key"] ? (
          <CardImage story={storyObj} defaultWidth={36} aspectRatio={[16, 9]} imageType="image16x9" />
        ) : (
          <Placeholder />
        )}
      </div>
    );
  }

  const contentView = (
    <React.Fragment>
      {imageView}
      <Headline text={storyObj.headline} headerType={10} headerLevel={3} />
    </React.Fragment>
  );

  // Check for external story
  if (referenceUrl) {
    containerView = (
      <a href={referenceUrl} target="_blank" rel="noopener noreferrer">
        {contentView}
      </a>
    );
  } else {
    containerView =
      storyObj["story-template"] === "visual-story" ? (
        <a href={`/${storyObj.slug}`} target="_blank" rel="noopener noreferrer">
          {contentView}
        </a>
      ) : (
        <Link href={`/${storyObj.slug}`}>{contentView}</Link>
      );
  }

  return <div styleName="container">{containerView}</div>;
};

CardImageType3.defaultProps = {
  isNcfNews: true
};

CardImageType3.propTypes = {
  story: object,
  headlineLimit: number,
  widths: array,
  isNcfNews: bool
};

export default CardImageType3;
